import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import instanceAPI from '../config/axiosconfig';

export const getParticipates = createAsyncThunk(
  'participate/getParticipates',
  async () => {
    const participates = await instanceAPI.get('/get-auctions')
      .then((resp) => resp.data.auctions);
    return participates;
  },
);

const participateSlice = createSlice({
  name: 'participate',
  initialState: {
    participates: [],
    status: null,
  },
  extraReducers: {
    [getParticipates.pending]: (state) => {
      state.status = 'loading';
    },
    [getParticipates.fulfilled]: (state, action) => {
      state.status = 'success';
      state.participates = action.payload;
    },
    [getParticipates.rejected]: (state) => {
      state.status = 'failed';
    },
  },
});

export default participateSlice.reducer;
